import React from 'react';
import { Redirect } from 'react-router-dom';
import { DAILY_CASH_CLOSE_PERMISSION } from 'pages/DailyCashClose/utils/permissions';
const DefaultPage = React.lazy(() => import('pages/DailyCashClose/pages/DefaultPage'));
const FormPage = React.lazy(() => import('pages/DailyCashClose/pages/FormPage'));
const StoreCashManagementRedirect = () => <Redirect to='/daily-cash-close' />;

const dailyCashCloseRoute = [
  {
    path: '/store-cash-management',
    exact: true,
    name: 'Quản lý quỹ cửa hàng',
    function: [DAILY_CASH_CLOSE_PERMISSION.VIEW, DAILY_CASH_CLOSE_PERMISSION.VIEW_ALL],
    any: true,
    component: StoreCashManagementRedirect,
  },
  {
    path: '/daily-cash-close',
    exact: true,
    name: 'Chốt quỹ cuối ngày',
    function: [DAILY_CASH_CLOSE_PERMISSION.VIEW, DAILY_CASH_CLOSE_PERMISSION.VIEW_ALL],
    any: true,
    component: DefaultPage,
  },
  { path: '/daily-cash-close/add', exact: true, name: 'Lập phiếu chốt quỹ', function: DAILY_CASH_CLOSE_PERMISSION.CREATE, component: FormPage },
  { path: '/daily-cash-close/edit/:id', exact: true, name: 'Sửa phiếu chốt quỹ', function: DAILY_CASH_CLOSE_PERMISSION.EDIT, component: FormPage },
  { path: '/daily-cash-close/detail/:id', exact: true, name: 'Chi tiết chốt quỹ', function: [DAILY_CASH_CLOSE_PERMISSION.VIEW, DAILY_CASH_CLOSE_PERMISSION.VIEW_ALL], any: true, component: FormPage },
];

export default dailyCashCloseRoute;
